// extracted by mini-css-extract-plugin
module.exports = {"root":"bn_bx","body":"bn_G"};